import craneImg from '../assets/illustrations/crane.png';
import circleOutline from '../assets/brand/circle_outline_green.svg';
import wavesGreen from '../assets/brand/waves_bottom_green.svg';
import dotsGrid from '../assets/brand/dots_grid.svg';

/**
 * Decorative background for the Rebase welcome screen: a base gradient, the
 * original construction photo (crane) placed bottom-left as-is — no visual
 * editing — plus scattered brand decor (outline circle, dots, bottom waves).
 */
const WelcomeBackground = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    {/* base mint→green gradient */}
    <div className="absolute inset-0 bg-gradient-to-b from-[#f3fbf6] via-[#e6f7ec] to-[#cdeed9]" />

    {/* original crane photo — bottom-left, embedded as-is (no editing) */}
    <img src={craneImg} alt="" className="absolute bottom-0 -left-16 hidden w-[44rem] lg:block lg:-left-24 lg:w-[68rem]" />

    {/* faint brand outline circle, mid-right */}
    <img
      src={circleOutline}
      alt=""
      className="absolute right-[6%] top-[34%] w-40 opacity-25 lg:right-[18%] lg:top-[28%] lg:w-56"
    />

    {/* dots grid cluster, upper area */}
    <img src={dotsGrid} alt="" className="absolute right-[8%] top-[12%] w-24 opacity-40 lg:right-[24%] lg:w-28" />
    <img src={dotsGrid} alt="" className="absolute left-[10%] top-[46%] w-16 opacity-25 lg:left-[24%]" />

    {/* solid brand accent dot */}
    <span className="absolute right-[30%] top-[9%] h-3.5 w-3.5 rounded-full bg-[#18B95B] opacity-70 lg:right-[42%]" />
    <span className="absolute left-[16%] top-[18%] h-2 w-2 rounded-full bg-[#0f8f5f] opacity-50 lg:left-[30%]" />

    {/* thin green wave lines pinned to the bottom */}
    <img src={wavesGreen} alt="" className="absolute inset-x-0 bottom-0 w-full opacity-70" />
  </div>
);

export default WelcomeBackground;
